import { createContext } from 'react';

type ModalContextType = {
  size: 'small' | 'medium' | 'large';
};

export const ModalContext = createContext<ModalContextType>({
  size: 'medium',
});
